var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintGroupLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 960,
    viewBox: "0 0 1440 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M950 325V324.5H949.767L949.617 324.678L950 325ZM1024.33 325C1024.33 326.473 1025.53 327.667 1027 327.667C1028.47 327.667 1029.67 326.473 1029.67 325C1029.67 323.527 1028.47 322.333 1027 322.333C1025.53 322.333 1024.33 323.527 1024.33 325ZM892.383 394.322L950.383 325.322L949.617 324.678L891.617 393.678L892.383 394.322ZM950 325.5H1027V324.5H950V325.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintGroupLine);
export default __webpack_public_path__ + "static/media/mintGroupLine.71344dd82005b228aaebcf0411829566.svg";
export { ForwardRef as ReactComponent };